import React from "react";
import Requirement from "./Requirement";
import styled from "styled-components";

const RequirementsWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-family:inherit;
  flex: 1 1 auto;
`;
const PasswordRequirements = ({requirements, font }) => (
    <section className="strength-meter">
        <RequirementsWrapper>
            <Requirement
                htmlFor="password"
                isvalid={requirements.long}
                message="8 characters"
            />
            <Requirement
                htmlFor="password"
                isvalid={requirements.number}
                message="1 number"
            />
        </RequirementsWrapper>
        <RequirementsWrapper>
            <Requirement
                htmlFor="uppercase"
                isvalid={requirements.uppercase}
                message="1 uppercase"
            />

            <Requirement
                htmlFor="specialchar"
                isvalid={requirements.specialchar}
                message="1 special character"
            />
        </RequirementsWrapper>
    </section>
);

export default PasswordRequirements;



// WEBPACK FOOTER //
// ./src/components/PasswordRequirements/PasswordRequirements.js